/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';



import { Configuration }                                     from '../configuration';


export interface DeleteBusinessPremisesRequestParams {
    businessPremisesId: string;
}

export class ClsDeleteBusinessPremisesRequestParams {
    businessPremisesId: string = undefined;
}

export interface DeleteContractRequestParams {
    contractId: string;
}

export class ClsDeleteContractRequestParams {
    contractId: string = undefined;
}

export interface DeleteErsRequestParams {
    ersId: string;
}

export class ClsDeleteErsRequestParams {
    ersId: string = undefined;
}

export interface DeleteOrganizationRequestParams {
    organizationId: string;
}

export class ClsDeleteOrganizationRequestParams {
    organizationId: string = undefined;
}

export interface DeleteTenantRequestParams {
    tenantId: string;
}

export class ClsDeleteTenantRequestParams {
    tenantId: string = undefined;
}

export interface DeleteTssRequestParams {
    tssId: string;
}

export class ClsDeleteTssRequestParams {
    tssId: string = undefined;
}


export interface AdminDeleteApiClientInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Delete an existing business premises
     * 
* @param requestParameters
     */
    deleteBusinessPremises(requestParameters: DeleteBusinessPremisesRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete a contract
     * Delete an existing contract.
* @param requestParameters
     */
    deleteContract(requestParameters: DeleteContractRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete an existing ers
     * 
* @param requestParameters
     */
    deleteErs(requestParameters: DeleteErsRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete an existing organization
     * 
* @param requestParameters
     */
    deleteOrganization(requestParameters: DeleteOrganizationRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete an existing tenant
     * 
* @param requestParameters
     */
    deleteTenant(requestParameters: DeleteTenantRequestParams, extraHttpRequestParams?: any): Observable<{}>;

    /**
     * Delete an existing TSS entity
     * 
* @param requestParameters
     */
    deleteTss(requestParameters: DeleteTssRequestParams, extraHttpRequestParams?: any): Observable<{}>;

}
